/* ============================================================================
   Section.tsx — wrapper visuel pour un groupe de contrôles.
   Header mono 11px caps tracking-wide stone, border-top 1px stone-light,
   padding vertical. Pas de collapse pour MVP — tout visible.
   ============================================================================ */

import type { ReactNode } from 'react';

interface SectionProps {
  title: string;
  /** Optionnel — petite annotation à droite du titre (ex: "L1") */
  hint?: string;
  children: ReactNode;
}

export function Section({ title, hint, children }: SectionProps) {
  return (
    <section className="controls-section" aria-label={title}>
      <header className="controls-section__title">
        <span>{title}</span>
        {hint ? <span className="controls-section__hint">{hint}</span> : null}
      </header>
      <div className="controls-section__body">{children}</div>
    </section>
  );
}
